import { call } from "../core";

export const callUpdateUser = body => {
  return call("/user", "PUT", { body });
};

export const callGetProfile = () => {
  return call("/profile", "GET", {});
};
